import { render, staticRenderFns } from "./declares.vue?vue&type=template&id=02e03e9a&scoped=true"
import script from "./declares.vue?vue&type=script&lang=js"
export * from "./declares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e03e9a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderType01: require('/var/www/html/jayuvillage/components/headerType01.vue').default,Quicks: require('/var/www/html/jayuvillage/components/quicks.vue').default,Navigation: require('/var/www/html/jayuvillage/components/navigation.vue').default})
